import script from "./holidays-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./holidays-modal.vue?vue&type=script&setup=true&lang=js"

import "./holidays-modal.vue?vue&type=style&index=0&id=438d668a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-438d668a"]])

export default __exports__